"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _hoisted_1 = { id: "WorldMap" };
const _hoisted_2 = { class: "WorldMapWrapper" };
const _hoisted_3 = ["width", "height"];
const _hoisted_4 = /*#__PURE__*/ (0, vue_1.createElementVNode)("defs", null, null, -1 /* HOISTED */);
const _hoisted_5 = ["transform"];
const _hoisted_6 = ["d", "data-iso"];
const _hoisted_7 = /*#__PURE__*/ (0, vue_1.createElementVNode)("g", null, null, -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ (0, vue_1.createElementVNode)("g", null, null, -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ (0, vue_1.createElementVNode)("g", null, null, -1 /* HOISTED */);
const _hoisted_10 = { class: "ZoomButtonsWrapper" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("svg", {
                width: _ctx.map.width,
                height: _ctx.map.height,
                onMousedown: _cache[3] || (_cache[3] =
                    //@ts-ignore
                    (...args) => (_ctx.startMapDraggingInteraction && _ctx.startMapDraggingInteraction(...args))),
                onMouseup: _cache[4] || (_cache[4] =
                    //@ts-ignore
                    (...args) => (_ctx.stopMapDraggingInteraction && _ctx.stopMapDraggingInteraction(...args))),
                onMousemove: _cache[5] || (_cache[5] =
                    //@ts-ignore
                    (...args) => (_ctx.updateMapPosition && _ctx.updateMapPosition(...args))),
                onTouchstart: _cache[6] || (_cache[6] =
                    //@ts-ignore
                    (...args) => (_ctx.startMapDraggingInteractionTouch && _ctx.startMapDraggingInteractionTouch(...args))),
                onTouchend: _cache[7] || (_cache[7] =
                    //@ts-ignore
                    (...args) => (_ctx.stopMapDraggingInteraction && _ctx.stopMapDraggingInteraction(...args))),
                onTouchmove: _cache[8] || (_cache[8] =
                    //@ts-ignore
                    (...args) => (_ctx.updateMapPositionTouch && _ctx.updateMapPositionTouch(...args)))
            }, [
                _hoisted_4,
                (0, vue_1.createElementVNode)("g", {
                    transform: `
				scale(${_ctx.map.scale})
				translate(${_ctx.getMapPosition('x')}, ${_ctx.getMapPosition('y')})
			`
                }, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.countries, (country) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("path", {
                            key: country.iso,
                            d: country.shape,
                            "data-iso": country.iso,
                            class: (0, vue_1.normalizeClass)([
                                country.iso === _ctx.hoveredCountryIso ? 'Hovered' : '',
                                country.iso === _ctx.selectedCountryIso ? 'Selected' : '',
                                'CountryShape'
                            ]),
                            onMouseover: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.setAsHovered && _ctx.setAsHovered(...args))),
                            onMouseout: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => (_ctx.setAsUnHovered && _ctx.setAsUnHovered(...args))),
                            onClick: _cache[2] || (_cache[2] =
                                //@ts-ignore
                                (...args) => (_ctx.setAsSelected && _ctx.setAsSelected(...args)))
                        }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_6));
                    }), 128 /* KEYED_FRAGMENT */))
                ], 8 /* PROPS */, _hoisted_5),
                _hoisted_7,
                _hoisted_8,
                _hoisted_9
            ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_3)),
            (0, vue_1.createElementVNode)("div", _hoisted_10, [
                (0, vue_1.createElementVNode)("button", {
                    class: "ZoomButton",
                    "data-zoom-action": "zoomIn",
                    onClick: _cache[9] || (_cache[9] =
                        //@ts-ignore
                        (...args) => (_ctx.mapZoom && _ctx.mapZoom(...args)))
                }, "+"),
                (0, vue_1.createElementVNode)("button", {
                    class: "ZoomButton",
                    "data-zoom-action": "zoomOut",
                    onClick: _cache[10] || (_cache[10] =
                        //@ts-ignore
                        (...args) => (_ctx.mapZoom && _ctx.mapZoom(...args)))
                }, "-")
            ]),
            (_ctx.hoveredCountry)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    key: 0,
                    class: "SelectedCountryLabel",
                    style: (0, vue_1.normalizeStyle)(`
				left: calc(${_ctx.map.labelCoordinates.x}px + 1rem);
				top: calc(${_ctx.map.labelCoordinates.y}px - 3rem);
			`)
                }, (0, vue_1.toDisplayString)(_ctx.hoveredCountry.name), 5 /* TEXT, STYLE */))
                : (0, vue_1.createCommentVNode)("v-if", true)
        ])
    ]));
}
exports.render = render;
